import React from "react";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import DefaultGroupPic from "site_media/images/groups_default.png";
import "containers/ProjectCommon.css";
import * as CONSTANT from "constants/text";
import { withStyles } from '@material-ui/core/styles';
import MuiCardMedia from '@material-ui/core/CardMedia';
import Button from "@material-ui/core/Button";

function GroupVeriticalCard(props) {

  const RoundedCardImage = withStyles((theme) => ({
    img: {
      clipPath: "circle(50px)",
    },
  }))(MuiCardMedia);


  return (
    <Card
      className={"friends_search_card_border2"}
      style={{ borderRadius: "6px" }}
    >
      <div style={{ paddingTop: "20px" }}>
        <RoundedCardImage
          onClick={() => (props.onImageClick())}
          className="friends_search_card"
          style={{
            objectFit: "contain",
            objectPosition: "center",
            cursor: props.type !== CONSTANT.FRIENDS ? "pointer" : "auto"
          }}
          component="img"
          image={props.imageSrc || DefaultGroupPic}
          alt={props.imageName}
        />

        <CardContent className="friends_search_card_text" style={{ paddingTop: "6px" }}>
          {props.imageName}
        </CardContent>
        <div
          style={{ width: "100%", textAlign: "center"}}
        >
          <Button
            size="small"
            color="primary"
            onClick={() => (props.onRemoveInvite())}
          >
            Remove Invite
              </Button>
        </div>
        <br />
      </div>
    </Card>
  );
}

export default GroupVeriticalCard;
